module.exports = __webpack_public_path__ + "static/media/7.b745ef0d.jpg";